import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-card',
  template: `
    <div class="la-card"
      [ngClass]="{
      'la-card--small': size === 'sm',
      'la-card--tile': type === 'tile',
      'la-card--tile-cell' : type === 'tile-cell',
      'la-card--tile-small' : (type === 'tile' && size === 'sm')}">
      <div class="la-card__tile-icon-box">
        <ng-content select="la-icon"></ng-content>
      </div>
      <div class="la-card__date-label-box">
        <ng-content select="la-date-label"></ng-content>
      </div>
      <div class="la-card__la-image-box">
        <ng-content select="la-image"></ng-content>
        <ng-content select="la-icon"></ng-content>
      </div>
      <div class="la-card__la-avatar-box">
        <ng-content select="la-avatar"></ng-content>
      </div>
      <div class="la-card__content">
        <!-- text will go to content below -->
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    @font-face{font-family:NeueHaasGrotDisp-45Light;font-style:normal;font-weight:300;src:url(assets/fonts/NeueHaasGrotDisp-45Light.woff) format("woff")}@font-face{font-family:NeueHaasGrotDisp-55Roman;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasGrotDisp-55Roman.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasUnicaPro-Regular.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:500;src:url(assets/fonts/NeueHaasUnicaPro-Medium.woff) format("woff")}.la-card .la-text.la-text--title-2{font-family:NeueHaasUnicaPro,sans-serif;font-weight:500}.la-card{position:relative;width:370px;height:297px;border-radius:15px;background-color:rgba(3,20,34,.03);padding-bottom:16px;overflow:hidden}.la-card:hover{box-shadow:0 0 15px 0 rgba(234,235,237,.74);background:#fff}.la-card__content{padding:16px;height:92px}.la-card .la-text.la-text--title-2{display:block;width:100%}.la-card .la-text.la-text--title-3{display:flex;width:100%;overflow:hidden;text-overflow:ellipsis;margin-top:4px;max-height:36px}.la-card .la-text.la-text--title-3 .la-icon:first-child{margin-right:8px}.la-card .la-card__date-label-box{position:absolute;top:16px;left:16px;z-index:1}.la-card .la-card__date-label-box .la-text--title-3{padding:1px 0 0;flex-direction:column}.la-card .la-card__tile-icon-box{position:absolute;bottom:16px;right:16px}.la-card .la-card__la-image-box{width:100%;height:203px;border-radius:15px 15px 0 0;overflow:hidden}.la-card .la-card__la-image-box .la-image .la-image__pic{width:370px;height:203px;-o-object-fit:cover;object-fit:cover}.la-card--small{width:272px;height:272px}.la-card--small .la-card__la-image-box{height:169px}.la-card--small .la-card__la-image-box .la-image .la-image__pic{width:272px;height:169px;-o-object-fit:cover;object-fit:cover}.la-card--tile{width:219px;height:200px;border-radius:8px}.la-card--tile .la-card__la-image-box{width:145px;margin:0 auto;height:145px}.la-card--tile .la-card__la-image-box .la-image .la-image__pic{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.la-card--tile-cell{width:370px;height:88px;border-radius:8px}.la-card--tile-cell .la-text--title-2{position:absolute;left:16px;top:23px}.la-card--tile-cell .la-text--title-3{position:absolute;left:16px;top:47px}.la-card--tile-cell .la-label{position:absolute;top:0;right:0;border-radius:0 8px 0 5px}.la-card--tile-small{width:145px;height:145px}.la-card--tile-small .la-text--title-2{position:absolute;left:16px;bottom:16px}.la-card--tile-small .la-date-label,.la-card__la-icon-box{position:absolute;top:0;left:0}.la-card__la-icon-box{display:flex;justify-content:center;align-items:center;height:200px;width:100px;margin:auto;right:0}.la-card__la-avatar-box{position:absolute;top:16px;right:16px}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaCardComponent {
  private _size = ''; // sm md
  private _type = 'card' // card, tile

  get size(): string {
    return this._size;
  }

  /**
   * sm - to make card size small. md by default
   */
  @Input()
  set size(size: string) {
    this._size = size;
  }
  get type(): string {
    return this._type;
  }

  /**
   * tile - to make tile shaped cards. Type card is by default
   */
  @Input()
  set type(type: string) {
    this._type = type;
  }
}
